import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { marked } from 'marked';
import React from 'react';

import SystemNoticeBanner from '@sophocles/components/SystemNotice/SystemNoticeBanner';

class SystemNoticeMessageBox extends React.Component {
  constructor(props) {
    super(props);
  }

  setText = e => {
    this.props.onChange(e.target.value);
  };

  // DOMPurify in SystemNoticeBanner provides sanitization; marked's deprecated
  // sanitize option is not used here.
  rawMarkup = () => marked(this.props.value === '' ? '&nbsp;' : this.props.value);

  render() {
    const { value } = this.props;

    return (
      <Stack sx={{ gap: 'var(--space-2)' }}>
        {/* Filled multiline pads the root, not the textarea, so a short value
            centers vertically in the 4-row slot unless anchored to the top;
            see SettingsTextField for the fuller writeup. */}
        <TextField
          label="Message"
          multiline
          minRows={4}
          fullWidth
          value={value}
          onChange={this.setText}
          sx={{
            '& .MuiInputBase-root.MuiInputBase-multiline': { alignItems: 'flex-start' },
            '& .MuiInputBase-inputMultiline': { alignSelf: 'flex-start', padding: '0 !important' },
          }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Link href="https://www.markdownguide.org/cheat-sheet" target="_blank" rel="noopener" variant="caption">
            markdown style guide
          </Link>
        </Box>

        <Stack sx={{ gap: 'var(--space-1)' }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {t('admin.preview', 'Preview')}
          </Typography>
          <Box
            sx={{
              border: '1px solid var(--border-default)',
              borderRadius: 'var(--radius-md)',
              p: 'var(--space-2)',
            }}
          >
            <SystemNoticeBanner
              close={() => alert("Why would you want to close the preview?\n\n  Sorry but I can't let you do that.")}
              html={this.rawMarkup()}
            />
          </Box>
        </Stack>

        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          Note: the banner will stretch to fit the user's screen so it may look slightly different to your users.
        </Typography>
      </Stack>
    );
  }
}

export default SystemNoticeMessageBox;
